import {useState} from "react";
import {useForm} from "react-hook-form";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const LoginForm = ({handleValidation}) => {
    const [passwordShown, setPasswordShown] = useState(false);

    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    const {
        register,
        formState: {errors},
        handleSubmit,
    } = useForm();

    const handleFormData = data => {
        handleValidation(data.userName, data.password);
    };

    return (
        <Box
            component="form"
            method="POST"
            onSubmit={handleSubmit(handleFormData)}
            sx={{
                my: 4,
                mx: 4,
                display: "flex",
                flexDirection: "column",
            }}
        >
            <TextField
                id="userName"
                {...register("userName", {
                    required: "Introduza o seu nome de utilizador",
                    maxLength: {
                        value: 20,
                        message:
                            "O nome de utilizador não pode ter mais de 20 caracteres",
                    },
                })}
                label="Nome do utilizador"
                name="userName"
                autoComplete="user name"
                autoFocus
                fullWidth
                margin="normal"
                error={Boolean(errors.userName)}
                helperText={errors.userName?.message}
            />
            <FormControl
                fullWidth
                margin="normal"
                variant="outlined"
                error={Boolean(errors.password)}
            >
                <InputLabel htmlFor="passwordInput">Senha</InputLabel>
                <OutlinedInput
                    id="passwordInput"
                    type={passwordShown ? "text" : "password"}
                    {...register("password", {
                        required: "Introduza a sua senha",
                        maxLength: {
                            value: 50,
                            message: "A senha não pode ter mais de 50 caracteres",
                        },
                    })}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="Mostrar senha/Ocultar senha"
                                onClick={togglePassword}
                                edge="end"
                                title="Mostrar senha/Ocultar senha"
                            >
                                {passwordShown ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    }
                    autoComplete="password"
                    label="Senha"
                />
            </FormControl>
            <Button type="submit" fullWidth variant="contained" sx={{mt: 3}}>
                Accesar
            </Button>
        </Box>
    );
};

export default LoginForm;
